
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.808","height":"19.655"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_27682","data-name":"Path 27682","d":"M331.272 260.41l-1.952-7.016a7.817 7.817 0 00-15.167.4l-1.506 6.774a3.085 3.085 0 003.013 3.756h2.071a4.584 4.584 0 008.6 0h1.969a3.091 3.091 0 002.975-3.909zm-8.66 5.161a2.9 2.9 0 01-3.006-1.252h4.855a2.889 2.889 0 01-1.848 1.252zm6.677-3.348a1.4 1.4 0 01-.993.411h-12.635a1.438 1.438 0 01-.3-.032 1.4 1.4 0 01-1.067-1.673l1.505-6.774a6.133 6.133 0 0111.9-.309l1.973 7.108a1.423 1.423 0 01.027.276 1.4 1.4 0 01-.41.993z","transform":"translate(-312.574 -247.661)","fill":"#262626"}})])
          )
        }
      }
    